<div class="page-title">
  <h1>Cadastrar grupo de empresas</h1>
</div>

<div class="actions" style="display: flex; align-items: center; justify-content: space-between">
  <div class="active-tag">
    <button [ngClass]="{'active-btn': isCadastrarDadosGeraisActive()}"
      (click)="chanceActiveScreen(CADASTRAR_DADOS_GERAIS)">
      Dados gerais
    </button>
    <div class="tab-with-tooltip">
      <button [ngClass]="{'active-btn': isListarEmpresasActive() || isCadastrarEmpresasActive(), 'disabled-tab': isEmpresasTabDisabled()}"
        [disabled]="isEmpresasTabDisabled()"
        (click)="chanceActiveScreen(LISTAR_EMPRESAS)">
        Empresas
      </button>
      <div *ngIf="isEmpresasTabDisabled()" 
           class="tooltip-icon"
           [title]="'Empresas disponível após finalização de dados gerais'">
        <img src="../../../assets/svg/icons/tooltip_ic.svg" alt="Info" />
      </div>
    </div>
  </div>

  <button matButton="filled" *ngIf="isListarEmpresasActive() && isMasterUser()" (click)="adicionarEmpresa()">
    <span style="margin-right: 6px; font-size: 16px">+</span> Adicionar empresa
  </button>
</div>

<form [formGroup]="grupoForm" *ngIf="isCadastrarDadosGeraisActive()">
  <app-cadastrar-grupo-dados-gerais [formData]="grupoForm.value" [readOnly]="isReadOnlyMode()" (formDataChange)="onFormDataChange($event)"
    (salvar)="saveDadosGerais()"></app-cadastrar-grupo-dados-gerais>
</form>

<app-cadastrar-grupo-empresas *ngIf="isListarEmpresasActive()"
  [idGrupo]="grupoSalvo?.id" 
  [readOnly]="isReadOnlyMode()"></app-cadastrar-grupo-empresas>